var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4138_16127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4443 25C13.3308 25 14.909 23.6551 15.2714 21.875H7.61719C7.97977 23.6551 9.55791 25 11.4443 25Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7449 12.499C18.7407 12.499 18.7365 12.5 18.7323 12.5C14.7126 12.5 11.4407 9.22906 11.4407 5.20837C11.4407 4.10307 11.6949 3.05822 12.1376 2.11866C11.9084 2.09692 11.6761 2.08337 11.4407 2.08337C7.4137 2.08337 4.14909 5.3478 4.14909 9.37498V12.2791C4.14909 14.3406 3.24596 16.2864 1.66152 17.626C1.13338 18.0771 0.898964 18.7958 1.08855 19.4969C1.30943 20.3125 2.11566 20.8334 2.96157 20.8334H19.9147C20.8021 20.8334 21.6387 20.2583 21.8188 19.3886C21.9584 18.7156 21.7188 18.0437 21.197 17.6052C19.6823 16.3355 18.8063 14.4697 18.7449 12.499Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9439 5.2084C23.9439 8.08487 21.6122 10.4166 18.7355 10.4166C15.8591 10.4166 13.5273 8.08487 13.5273 5.2084C13.5273 2.33192 15.8591 0 18.7355 0C21.6122 0 23.9439 2.33192 23.9439 5.2084Z",
    fill: "#515151"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4138_16127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a98b2a50b54bffa9a22fb78a45b6ade1.svg";
export { ForwardRef as ReactComponent };